import React from 'react'
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import { loadAddressAsync } from '../../services/address/addressSlice';
import { useDispatch,useSelector } from 'react-redux';
import { checkUserIsNotGuest } from '../../utils/helpers';

export default function RefreshAddressButton() {

 const dispatch = useDispatch();
 const auth = useSelector(state => state.auth);
 const dynamicState = useSelector(state => state.dynamicConfig);
 const user = useSelector(state => state.auth.user);

 const handleRefresh = () => {
   // Only refresh addresses for authenticated users
   if (checkUserIsNotGuest(user)) {
     dispatch(loadAddressAsync({auth,dynamicState}));
   }
 };

  return (
    <Button 
      className='refresh-button' 
      onClick={handleRefresh}
      disabled={!checkUserIsNotGuest(user)}
    >
       <RefreshIcon />
    </Button>
  )
}
